import { Box, BoxProps, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLText } from '..';

interface NumberBadgeProps {
  number?: string | number;
  iconSize?: number;
  backgroundColor?: BoxProps['backgroundColor'];
  numberColor?: BoxProps['color'];
}

const NumberBadge: React.FC<NumberBadgeProps> = ({
  number,
  iconSize = 56,
  backgroundColor = 'blue.600',
  numberColor = 'white',
}) => {
  const fontSize = iconSize - 16;
  const styles = useStyleConfig('NumberBadge', {});

  return (
    <Box
      __css={styles}
      backgroundColor={backgroundColor}
      boxSize={`${iconSize}px`}
      width={`${iconSize}px`}
      height={`${iconSize}px`}
    >
      <WLText color={numberColor} fontSize={`${fontSize}px`}>
        {number}
      </WLText>
    </Box>
  );
};

export default NumberBadge;
